export enum EHostType {
  /* страница чатов */
  Page = 'page',
  /* диалоговое окно на внешней странице (например, чат на каоб) */
  Frame = 'frame',
  /* страница чатов в лк (встраивается вся страница полностью) */
  DesktopFrame = 'desktopFrame',
}
